import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Row, Col, Form, Input, Spin, Empty, Icon } from 'antd';
import moment from 'moment';
import { ENV } from '@/services/utils';
import Container from '../../../../../components/Container';
import RuleModal from './RuleModal';
import { getAppCode } from '../../utils/utils';
import { getStarNumber } from '../../utils/convertData';
import styles from './index.less';
import emptyImg from '../images/empty_n.png';

const hostName = {
  test: 'test.m.xiaoyuanhao.com',
  dev: 'test.m.xiaoyuanhao.com',
  production: 'm.xiaoyuanhao.com',
};

const star0 = 'https://s.xiaoyuanhao.com/image/micro/star_0.png';
const starFull = 'https://s.xiaoyuanhao.com/image/micro/star_full.png';
const starHalf = 'https://s.xiaoyuanhao.com/image/micro/star_half.png';

const starType = {
  full: starFull,
  half: starHalf,
  zero: star0,
};
@connect()
class LatestNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      totalElements: 0,
      schoolNum: '',
      showSearchResult: false,
      showModal: false,
      data: {},
      orgid: '',
    };
    this.appCode = getAppCode();
  }

  componentDidMount() {
    this.fetchOrgid();
  }

  search = e => {
    e.preventDefault();
    const that = this;
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { orgid } = this.state;
        this.setState({
          showSearchResult: true,
        });
        const schoolname = values.title ? encodeURIComponent(values.title) : '';
        that.fetchBureau(orgid, schoolname);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { orgid } = this.state;
    this.setState({ showSearchResult: false });
    this.fetchBureau(orgid, '');
  };

  fetchOrgid = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'latestNews/fetchOrgid',
    })
      .then(res => {
        this.fetchBureau(res.orgid);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchBureau = (bureauId, schoolname) => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'schoolMatrix/fetchAll',
      params: {
        bureauId,
        appCode: this.appCode,
        schoolname,
      },
    })
      .then(res => {
        const length = this.getLength(res);
        const schoolNum = res.underlingOrgList && res.underlingOrgList.length;
        this.setState({
          loading: false,
          data: res,
          schoolNum,
          orgid: bureauId,
          totalElements: length,
        });
      })
      .catch(error => {
        console.log('error', error);
        this.setState({ loading: false });
      });
  };

  getLength = data => {
    const { levelOrgList = [], selfOrg = {}, superOrgList = [], underlingOrgList = [] } =
      data || {};
    const length =
      levelOrgList.length + superOrgList.length + underlingOrgList.length + (selfOrg ? 1 : 0);
    return length;
  };

  toMicrosite = params => {
    window.open(`//${hostName[ENV]}/micro/app/micrositeV4?${params}`);
  };

  renderSchoolItem = item => {
    const { orgLogo, orgname, orgid, score } = item;
    const starNumber = getStarNumber(Number(score));
    const params = `orgid=${orgid}&appCode=${this.appCode}&fromWeb=web`;
    return (
      <div className="school-item" onClick={() => this.toMicrosite(params)}>
        <img src={orgLogo} alt="" />
        <div>{orgname}</div>
        <div className="star-wrap">
          {starNumber.map(ele => {
            return <img className="star-style" src={starType[ele]} alt="" />;
          })}
        </div>
      </div>
    );
  };

  renderTime = updateTime => {
    return (
      <div className="rule-info">
        <div onClick={() => this.setState({ showModal: true })}>
          规则说明
          <Icon type="right" />
        </div>
        <div>
          更新时间：
          {updateTime ? moment(updateTime).format('YYYY.MM.DD HH:mm') : ''}
        </div>
      </div>
    );
  };

  renderGroup = (type, data, schoolNum) => {
    const { orgname, orgLogo, updateTime = '', orgid, score } = data;
    const starNumber = getStarNumber(Number(score));
    const params = `orgid=${orgid}&appCode=${this.appCode}&fromWeb=web`;
    return (
      <div className="header">
        <span onClick={() => window.open(`//${hostName[ENV]}/micro/app/micrositeV4?${params}`)}>
          <img src={orgLogo} alt="" />
        </span>
        <div
          className="name"
          onClick={() => window.open(`//${hostName[ENV]}/micro/app/micrositeV4?${params}`)}
        >
          <div>{orgname}</div>

          {type === 'current' && <div>下属{schoolNum}所学校</div>}
          <p className="star-wrap">
            {starNumber.map(ele => {
              return <img className="star-style" src={starType[ele]} alt="" />;
            })}
          </p>
        </div>

        {type === 'current' && this.renderTime(updateTime)}
      </div>
    );
  };

  render() {
    const { loading, showSearchResult, totalElements, schoolNum, showModal, data } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
    };

    const { levelOrgList = [], selfOrg = {}, superOrgList = [], underlingOrgList = [] } =
      data || {};

    return (
      <Container breStates isSplitBar>
        <div className={styles.root}>
          <Row className={styles['search-area']}>
            <Col span={10}>
              <Form.Item {...formItemLayout} label="名称">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入名称" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col offset={20} style={{ textAlign: 'right' }}>
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <Spin spinning={loading}>
            {showSearchResult && (
              <div className="search-result">
                搜索到 <span>{totalElements}</span> 所学校
              </div>
            )}
            <section className="education-info">
              {superOrgList.length > 0 && (
                <>
                  <div className="title-1">上级组织</div>
                  <div className="super-org-wrap">
                    {superOrgList.map(item => {
                      return this.renderGroup('', item, '');
                    })}
                  </div>
                </>
              )}
              {selfOrg && (
                <>
                  <div className="title-1">本组织</div>
                  {this.renderGroup('current', selfOrg, schoolNum)}
                </>
              )}
            </section>
            <div className="school-list">
              {underlingOrgList.length > 0 && (
                <>
                  <div className="title-1">下级组织</div>
                  <section className="table-area">
                    {underlingOrgList.map(item => {
                      return this.renderSchoolItem(item);
                    })}
                  </section>
                </>
              )}
              {levelOrgList.length > 0 && (
                <>
                  <div className="title-1">同级组织</div>
                  <section className="table-area">
                    {levelOrgList.map(item => {
                      return this.renderSchoolItem(item);
                    })}
                  </section>
                </>
              )}
            </div>

            {/* {!dataSource.length && (
              <Empty image={emptyImg} description="暂无学校" imageStyle={{ marginTop: 51 }} />
            )} */}
          </Spin>
          <RuleModal showModal={showModal} onCancel={() => this.setState({ showModal: false })} />
        </div>
      </Container>
    );
  }
}

const ArticleLatestNews = Form.create()(LatestNews);
export default ArticleLatestNews;
